import type { FoodItem, MenuResponse } from './types';
import { campusDateTime } from '@/app/lib/campusTime';

export const DINING_HALLS = [
  { key: 'livingston', label: 'Livingston', subtitle: 'Livingston Dining Commons' },
  { key: 'busch', label: 'Busch', subtitle: 'Busch Dining Hall' },
  { key: 'neilson', label: 'Neilson', subtitle: 'Neilson Dining Hall' },
] as const;
export const DINING_MEALS = [{ key: 'breakfast', label: 'Breakfast' }, { key: 'lunch', label: 'Lunch' }, { key: 'dinner', label: 'Dinner' }] as const;
export type DiningLoadError = { message: string; diagnostic: string };
export type DiningDirectoryViewModel = { hall: string; meal: string; date: string; menu: MenuResponse | null; loading: boolean; error: DiningLoadError | null; selectedItem: FoodItem | null; loadedAt: string | null; searchQuery: string; vegetarianOnly: boolean };

export function filterDiningMenu(menu: MenuResponse | null, searchQuery: string, vegetarianOnly: boolean): MenuResponse | null {
  if (!menu) return null;
  const normalizedQuery = searchQuery.trim().toLowerCase();
  const stations = menu.stations.map((station) => ({ ...station, items: station.items.filter((item) => {
    if (normalizedQuery && !item.name.toLowerCase().includes(normalizedQuery) && !item.description.toLowerCase().includes(normalizedQuery)) return false;
    return !vegetarianOnly || Boolean(item.dietary?.vegetarian || item.dietary?.vegan);
  }) })).filter((station) => station.items.length > 0);
  return { ...menu, stations };
}
export function diningItemCount(menu: MenuResponse | null) { return menu?.stations.reduce((total, station) => total + station.items.length, 0) ?? 0; }
export function diningHallMeta(hall: string) { return DINING_HALLS.find((candidate) => candidate.key === hall) ?? DINING_HALLS[0]; }

/** Dining dates follow the Rutgers campus day, including after UTC midnight. */
export function diningToday(now = new Date()) {
  return campusDateTime(now).date;
}
